import React, { useEffect, useMemo, useState } from 'react';
import { Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { reportingOp } from 'store/ducks/Reportings';
import { RootState } from 'store/configureStore';
import { set_isDisplayed } from 'store/ducks/Reportings/reportingSlice';
import { columnsB0502 } from 'constants/reportColumns';
import { BProps, DataTypeB0502 } from 'store/ducks/Reportings/types';

const B0502: React.FC<BProps> = ({ entityName }) => {
  const { date, is_displayed, headers } = useSelector(
    (state: RootState) => state.reportings,
  );
  const [data, setData] = useState<DataTypeB0502[]>([]);
  const dispatch = useDispatch();
  const fetchData = async () => {
    dispatch(set_isDisplayed(false));
    const entityIds: string[] = entityName
      ? entityName.split(',').map((id) => id.trim())
      : [];

    const params = {
      entityId: entityIds,
      date,
    };

    try {
      const fetchedData = await reportingOp.fetchRT0502(params);

      if (fetchedData && fetchedData.entities) {
        const date = fetchedData.date;
        const allEntities = Object.values(fetchedData.entities).flat();

        const formattedData = allEntities.map(
          (dataItem: any, index: number) => ({
            key: index,
            date,
            entity_name: dataItem.entity_name,
            contractual_arrangement_ref_number:
              dataItem['Contractual arrangement ref. number'],
            type_of_ICT: dataItem['Type of ICT services'],
            identification_code_of_ICT_provider:
              dataItem['ICT service provider code'],
            type_of_code_to_identify_provider:
              dataItem['Type of ICT service provider code'],
            rank: dataItem['Rank'],
            identification_code_of_recipient: dataItem['Recipient ID code'],
            type_of_code_to_identify_recipient: dataItem['Recipient ID type'],
          }),
        );

        setData(formattedData);
      } else {
        setData([]);
      }
    } catch (error) {
      console.log('Error fetching branches:', error);
      setData([]);
    }
  };

  useEffect(() => {
    if (entityName) {
      fetchData();
    }
  }, [is_displayed, entityName]);

  return (
    <>
      <Table
        columns={columnsB0502}
        dataSource={data}
        scroll={{ x: 1000, y: 430 }}
      />
    </>
  );
};

export default B0502;
